/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment
     */
    commentJp?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment
     */
    commentEn?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment {
    return JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'commentJp': !exists(json, 'commentJp') ? undefined : json['commentJp'],
        'commentEn': !exists(json, 'commentEn') ? undefined : json['commentEn'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'commentJp': value.commentJp,
        'commentEn': value.commentEn,
    };
}

